import React from 'react'
import './HeroSection.css'
import { ReactTyped } from "react-typed";

const HeroSection = () => {
  return (
     <>
    <div id="HeroSection">  
            <h2 className="MyName">Hello! I am Sathya Krishnamurthy</h2>
            
 
      <div className="TypewriterTxt">
        <h1 className='infoText'>
          I am{" "}
          <ReactTyped 
          strings={["a product designer ", "a ux engineer ", "a graphic designer", "a digital designer", "an aesthete "]} 
          typeSpeed={150} loop
          backSpeed={30}
          cursorChar='|'
          showCursor={true} />
        </h1> <br />

        <div className="ribbon">
           <h3> ⚠ Please note: The website is under development. </h3>
        </div>
      </div>
    </div>

    {/* <div className="aesthete" >
      <p>aes·thete - a person who has or affects to have a special appreciation of art and beauty.
      </p>
    </div> */}
    </>

  

  )
}

export default HeroSection